var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-md-body-1 text-sm-caption text-caption text-center rehab-gray"},[_c('label',[_vm._v("リハプランの")]),_vm._v(" "),_c('external-link',{attrs:{"link-info":_vm.$t('view.dictionary.link.rehaplan_privacy')}}),_vm._v(" "),_c('label',[_vm._v("に同意のうえ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f29243d2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/globals/Policy.vue
// module id = ucXq
// module chunks = 1